<template>
  <div class="journey-group-item py-2" :style="styleObject">
    <div class="journey-container" :data-unique-key="solution.uniqueKey">
      <!-- Desktop View -->
      <div class="columns is-mobile is-gapless mb-0 pr-1 is-hidden-touch">
        <!-- AIRLINE LOGO -->
        <div class="column is-narrow has-text-centered wrap">
          <div class="mt-1 airlineLogo">
            <div v-if="solution.airlineCode == 'Multiple'">
              <span class="is-size-7">Multiple Airlines</span>
            </div>
            <img
              v-else
              width="20"
              :src="
                solution.airlineCode
                  ? $helpers.airlineLogo(solution.airlineCode, 20, 20)
                  : ''
              "
            />
          </div>
        </div>
        <!-- FROM-TO -->
        <div
          class="column is-narrow"
          data-style="result-airport-row"
          style="width:135px"
        >
          <div
            v-for="(journey, journeyIndex) in solution.journeys"
            :key="journeyIndex"
          >
            <div class="columns is-mobile is-gapless mb-2">
              <div class="column is-narrow mr-2">
                <div
                  class="has-text-weight-bold"
                  data-test="result-journey-from"
                >
                  {{ journey.from }}
                </div>
              </div>
              <div class="column is-narrow mr-2">
                <span class="is-size-7 mt-1 is-block">
                  <b-icon
                    icon="arrow-right"
                    size="is-small"
                    class="has-text-grey-light"
                  ></b-icon>
                </span>
              </div>
              <div class="column is-narrow mr-4">
                <div class="has-text-weight-bold" data-test="result-journey-to">
                  {{ journey.to }}
                </div>
              </div>
              <div
                v-if="roundTripDifferentAirports && journeyIndex == 1"
                class="column is-narrow ml-1"
              >
                <span class="has-text-danger is-size-7">multiple airports</span>
              </div>
            </div>
            <div class="columns mb-1">
              <div
                data-test="result-airline-name"
                class="is-size-7 has-text-grey-light ml-3"
              >
                {{ $helpers.airlineName(journey.airlineCode) }}
              </div>
            </div>
          </div>
        </div>
        <!-- DEPARTURE-ARRIVAl -->
        <div class="column">
          <div
            v-for="(journey, journeyIndex) in solution.journeys"
            :key="journeyIndex"
          >
            <div class="is-inline is-size-7" data-test="result-flight-time">
              {{ journey.legs[0].departingAt.time | formatTime }} -
              {{ journey.legs.slice(-1).pop().arrivingAt.time | formatTime }}
            </div>
            <span class="ml-2 is-inline is-size-7 has-text-grey-light">
              <!-- {{ journey.legs[0].departingAt.date | formatDate}} -->
              <span
                class="is-size-7 has-text-danger"
                v-if="journey.dateDifference > 0"
              >
                +{{ journey.dateDifference }}
                <span v-if="journey.dateDifference == 1">day</span>
                <span v-if="journey.dateDifference > 1">days</span>
              </span>
            </span>
            <!--<span class="is-block is-size-7 ml-2 has-text-danger" v-if="journey.dateDifference > 0">
              <span v-if="journey.dateDifference == 1">arrives next day</span>
              <span v-if="journey.dateDifference > 1">arrives {{ journey.dateDifference }} days layer</span>
            </span>-->
            <div class="is-size-7 has-text-grey-light">&nbsp;</div>
          </div>
        </div>
        <!-- DURATION -->
        <div class="column is-narrow has-text-right" style="width:80px">
          <div
            v-for="(journey, journeyIndex) in solution.journeys"
            :key="journeyIndex"
          >
            <span class="has-text-grey-dark is-size-7 mr-2">{{
              journey.travelDuration | formatDuration
            }}</span>
            <div class="is-size-7 has-text-grey-light">&nbsp;</div>
          </div>
        </div>
        <!-- STOPS -->
        <div class="column is-narrow has-text-left mr-4" style="width:55px">
          <div
            v-for="(journey, journeyIndex) in solution.journeys"
            :key="journeyIndex"
          >
            <span class="has-text-grey-light is-size-7 ml-2">{{
              (journey.legs.length - 1) | formatLayovers
            }}</span>
            <div class="is-size-7 has-text-grey-light">&nbsp;</div>
          </div>
        </div>
        <!-- UNUSED TICKET -->
        <div class="column has-text-centered is-narrow" style="width:40px;">
          <div
            class="is-inline-block"
            v-if="unusedTickets.includes(solution.journeys[0].airlineCode)"
          >
            <b-icon icon="currency-usd" size="is-small" type="is-info"></b-icon>
          </div>
        </div>
        <!-- OUT OF POLICY TAG -->
        <!-- <div class="column is-narrow" style="width:80px;">
          <OutOfPolicyTag position="is-bottom" :travelPolicy="solution.travelPolicy"></OutOfPolicyTag>
        </div> -->
        <!-- PRICE RANGE -->
        <div class="column is-narrow has-text-right mr-2" style="width:80px">
          <span class="has-text-grey-dark is-size-7 has-text-weight-bold">
            <span>{{ solution.pricing.total | formatPriceFromDollars }}</span>
          </span>
        </div>
        <!-- FARE RULES (One-Way Only) -->
        <div class="column is-narrow" v-if="isOneWay">
          <div class="is-flex">
            <div
              class="is-inline-block mr-2 is-clickable"
              @click="fareRulesModal(solution.journeys)"
            >
              <b-icon
                icon="alpha-f-circle"
                size="is-default"
                class="has-text-grey-lighter"
              >
              </b-icon>
            </div>
          </div>
        </div>
        <!-- RATING -->
        <div class="column is-narrow">
          <div class="mr-2">
            <!-- $popper Tooltip -->
            <section class="is-inline-block ml-1 mr-1">
              <div ref="topArrow">
                <span
                  class="score is-clickable"
                  :class="scoreClass"
                  @mouseenter="
                    $popper.togglePopper($refs.topArrow, $refs.topMenu)
                  "
                  @mouseleave="
                    $popper.togglePopper($refs.topArrow, $refs.topMenu)
                  "
                >
                  <span class="score-numerator inner-circle">{{
                    scoreOutOfTen
                  }}</span>
                </span>
              </div>
              <div
                ref="topMenu"
                class="filterBox popper-popup"
                style="background: #eee; max-width: 200px;"
              >
                <p class="is-size-7">
                  Rating is based on price, travel duration, company
                  preferences, and travel preferences.
                </p>
                <div class="popper-arrow"></div>
              </div>
            </section>
          </div>
        </div>
        <!-- FLIGHT INFO -->
        <div class="column is-narrow">
          <div class="is-flex">
            <div
              class="is-inline-block mr-1 is-clickable"
              @click="toggleDetails"
            >
              <!--              <b-icon-->
              <!--                  icon="information"-->
              <!--                  size="is-default"-->
              <!--                  class="has-text-grey-lighter"-->
              <!--              />-->
              <b-button type="is-outlined" size="is-small"
                >View Details</b-button
              >
            </div>
            <div
              v-if="
                solution.isSelectable &&
                  solution.immediateTravelBookingAdvice != 'prevent'
              "
              class="is-inline-block is-clickable"
              @click="checkSubmission(solution)"
              style="width: 70px;"
            >
              <b-button
                type="is-primary"
                size="is-small"
                data-test="book-price-result"
                >Book</b-button
              >
            </div>
          </div>

          <div
            v-if="!solution.isSelectable"
            class="mt-4 is-size-7 has-text-grey is-block"
          >
            Not selectable
          </div>

          <div
            v-if="
              solution.isSelectable &&
                solution.immediateTravelBookingAdvice == 'prevent'
            "
            class="mt-4 notification is-size-7 has-text-grey has-text-centered"
          >
            To book this option call: <br />
            877-924-0303
          </div>

          <OutOfPolicyTag
            class="mt-3"
            position="is-left"
            :travelPolicy="solution.travelPolicy"
          />

          <PreferredVendorTag
            class="mt-3"
            position="is-left"
            v-if="isPreferredVendor"
            type="air"
          ></PreferredVendorTag>

          <!-- Immediate travel -->
          <div v-if="solution.immediateTravelBookingAdvice">
            <ImmediateTravelNote
              :severity="solution.immediateTravelBookingAdvice"
              class="mb-2"
            />
          </div>
          <!-- End Immediate travel -->
        </div>
        <!--  SEAT MAP -->
        <!--        <div class="column is-narrow mr-1">-->
        <!--          <div class="is-flex">-->
        <!--            <div class="is-inline-block is-clickable" @click="goToSeatMaps()">-->
        <!--              <b-button type="is-outlined" size="is-small">-->
        <!--                <span class="">Seat Maps</span>-->
        <!--              </b-button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <!-- end of .columns -->
      <!-- end of Desktop View -->

      <!-- Mobile View  -->
      <div class="is-hidden-desktop">
        <ResultByPriceMobileView
          :solution="solution"
          @display="toggleDetails"
          :preferredVendors="preferredVendors"
        />
      </div>
      <!-- end of Mobile View  -->
    </div>
    <!-- end of .journey-container -->

  </div>
</template>

<script>
import FlightDetails from "./FlightDetails.vue";
import SeatMapMenu from "../../SeatMap/SeatMapMenu.vue";
import meetingsMixin from "@/mixins/meetingsMixin";
import modalMixin from "@/mixins/modalMixin";
import bookingMixin from "@/mixins/bookingMixin";
import ResultByPriceMobileView from "./ResultByPriceMobileView";
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import ImmediateTravelNote from "../../Traveller/ImmediateTravelNote";
import PreferredVendorTag from "../../Tags/PreferredVendorTag.vue";
import AddMeetingGuest from "../../Meetings/AddMeetingGuest.vue";

export default {
  name: "PriceResult",
  mixins: [meetingsMixin, modalMixin, bookingMixin],
  components: {
    ResultByPriceMobileView,
    //FlightDetails,
    OutOfPolicyTag,
    ImmediateTravelNote,
    PreferredVendorTag,
  },
  props: {
    solution: Object,
    first_selected: Boolean,
    tripVal: Number,
    preferredVendors: Array,
  },
  data: function() {
    return {
      display_full: false,
      show: false,
      path: "",
      time: "",
      price: "",
      score: "",
      stops: [],
      scoreOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isDesktop: true,
      //showDetails: false,
    };
  },
  computed: {
    //determine whether the flight details display is set to the current row
    activeRow(){
      return this.$store.state.bookTravel.flightDetails.show && (JSON.stringify(this.$store.state.bookTravel.flightDetails.journeys) === JSON.stringify(this.solution.journeys));
    },
    styleObject() {
      let obj = {};
      if (this.activeRow) {
        obj = {
          background: "rgba(248, 234, 207, 0.6)",
        };
      }
      return obj;
    },
    unusedTickets() {
      if (this.pathMixin_isMeeting) {
        return [];
      }
      if (
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .unusedTicketAirlines
      ) {
        return this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].unusedTicketAirlines;
      } else {
        return [];
      }
    },
    roundTripDifferentAirports(journeyIndex) {
      if (this.tripVal == 1) {
        return (
          this.solution.journeys[0].from != this.solution.journeys[1].to ||
          this.solution.journeys[0].to != this.solution.journeys[1].from
        );
      }
      return false;
    },
    triggerMessages() {
      var message = "";
      for (
        let i = 0;
        i < this.solution.travelPolicy.rulesTriggered.length;
        i++
      ) {
        message +=
          this.solution.travelPolicy.rulesTriggered[i].message + "  |  ";
      }
      return message;
    },
    scoreOutOfTen() {
      return this.$options.filters.displayScore(this.solution.score);
    },
    scoreClass() {
      return (
        "score-" + this.scoreOutOfTen + " outer-circle-" + this.scoreOutOfTen
      );
    },
    scoreOptionClass() {
      return "score-bar-" + this.scoreOutOfTen;
    },
    activeScoreBarClass() {
      return "active-score-bar";
    },
    flightForItinerary() {
      var sol = this.solution;
      sol.unusedTicket = this.unusedTickets.includes(
        sol.journeys[0].airlineCode
      );
      for (var i = 0; i < sol.journeys.length; i++) {
        // console.log(i)
        for (var j = 0; j < sol.journeys[i].legs.length; j++) {
          // console.log(j)
          sol.journeys[i].legs[j].selectedSeat = false;
        }
      }
      return sol;
    },
    solutionAirlineCodes() {
      var airlines = [];

      for (let journey of this.solution.journeys) {
        airlines.push(journey.airlineCode);
      }

      return airlines;
    },
    solutionAirlineNames() {
      var airlineNames = [];

      for (let airlineCode of this.solutionAirlineCodes) {
        airlineNames.push(this.$globals.airlineNames[airlineCode]);
      }

      return airlineNames;
    },
    isPreferredVendor() {
      return this.solution.isPreferred;
      //return this.preferredVendors.includes(this.solution.airlineCode);
    },
  },
  methods: {
    checkSubmission(sol) {
      // console.log('checkSubmission', sol);

      if (sol.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a flight with a departure time in the next few hours. Please watch your email for your Final Ticketed Itinerary.  If you do not receive your Final Ticketed Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.   ",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.submitted(sol),
        });
      } else {
        this.submitted(sol);
      }
    },
    filterByFlight(val) {
      this.display_full = false;
      this.$emit("filter", val);
    },
    async flightSelected() {
      this.$store
        .dispatch("bookTravel/alterResult", this.solution)
        .then(this.$router.push({ path: "/itinerary" }));
    },
    display() {
      this.display_full = !this.display_full;
      //// console.log('called display()');
    },
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        (airportItem) => airportItem.code === airportCode
      );

      if (!airport) return null;

      return airport.city + ", " + airport.state;
    },
    goToSeatMaps() {
      var details;
      details = {
        parent: this,
        component: SeatMapMenu,
        props: {
          activeTab: 0,
          flightProp: this.solution.journeys,
          preview: true,
        },
        hasModalCard: true,
        trapFocus: true,
      };
      this.$buefy.modal.open(details);
    },
    availableSeats(num) {
      if (num == "9") {
        return "9+";
      }
      return num;
    },
    checkScreenSize() {
      if (window.innerWidth <= 1023) {
        // console.log('window.innerWidth: ', window.innerWidth);
        this.isDesktop = false;
      }
    },
    submitted(value) {
      // console.log('submitted', value);
      this.$store.dispatch("bookTravel/alterResult", value);

      if (this.pathMixin_isMeeting) {
        this.meetingRouter();

        if (this.meetingInfo.allowedToBringGuest) {
          this.$buefy.modal.open({
            parent: this,
            component: AddMeetingGuest,
            props: {},
            hasModalCard: true,
            trapFocus: true,
            width: 650,
          });
        }
      } else {
        this.$nav.pushRouteTo({ name: "BookingItinerary" });
      }
    },
    toggleDetails() {
      if (this.$store.state.bookTravel.flightDetails.show) {
        this.$store.commit("bookTravel/HIDE_FLIGHT_DETAILS");
      } else {
        let details = {
          show: true,
          journeys: this.solution.journeys
        }
        this.$store.commit("bookTravel/SET_FLIGHT_DETAILS", details);
      }
    },
  },
  mounted() {
    this.checkScreenSize();

    // this.sol.unusedTicket = this.unusedTickets.includes(this.sol.journeys[0].airlineCode);
    // for (var i = 0; i < this.sol.journeys.length; i++){
    //   for (var j = 0; j < this.sol.journeys[i].legs.length; j++){
    //     this.$set(this.sol.journeys[i].legs[j], 'selectedSeat', false)
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
$scoreColors: (
  "10": #39996b,
  "9": #47ba41,
  "8": #abba19,
  "7": #f0dd01,
  "6": #ffce00,
  "5": #ffa600,
  "4": #ff7500,
  "3": #ff4e02,
  "2": #d21d00,
  "1": #a52620,
);
@each $score, $color in $scoreColors {
  .inner-circle {
    border-radius: 106%;
    display: inline-block;
    padding: 0;
    height: 22px;
    width: 22px;
    font-size: 12px;
    background: white;
  }
  .outer-circle-#{$score} {
    border-radius: 50%;
    display: inline-block;
    padding: 2px 2px 25px 2px;
    height: 28px;
    width: 28px;

    @if $score == "10" {
      background: linear-gradient(-20deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(to right, $color 50%, transparent 0),
        $color;
    } @else if $score == "9" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(54deg, $color 50%, transparent 0),
        white;
    } @else if $score == "8" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(18deg, $color 50%, transparent 0),
        white;
    } @else if $score == "7" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-18deg, $color 50%, transparent 0),
        white;
    } @else if $score == "6" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-54deg, $color 50%, transparent 0),
        white;
    } @else if $score == "5" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-90deg, $color 50%, transparent 0),
        white;
    } @else if $score == "4" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(54deg, white 50%, transparent 0),
        $color;
    } @else if $score == "3" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(18deg, white 50%, transparent 0),
        $color;
    } @else if $score == "2" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-18deg, white 50%, transparent 0),
        $color;
    } @else if $score == "1" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-54deg, white 50%, transparent 0),
        $color;
    }
  }
  .score-#{$score} {
    //border: darken($color, 5) 2px solid;
    color: darken($color, 30);
    text-align: center;
    margin-left: 5px;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
  }

  .score-bar-#{$score} {
    background-color: $color;
    text-align: center;
    width: 10px;
    height: 5px;
    display: inline-block;
    margin-left: 1px;
    font-weight: bold;
    font-size: 0;
    color: white;
  }
}
.active-score-bar {
  height: 20px;
  width: 20px;
  font-size: 12px;
  line-height: 20px;
}
.score-denominator {
  font-size: 10px;
  color: #aaa;
  display: none;

  &:before {
    content: "/";
    margin-left: 3px;
    margin-right: 3px;
    color: #ccc;
  }
}
.journey-details {
  //padding-left: 80px;
  padding: 0 5px;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
